import { MarkovRedistribution } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setMarkovRedistributions = (redistributions: MarkovRedistribution[]) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTIONS),
    redistributions,
})
export const setMarkovRedistributionSelected = (redistribution: MarkovRedistribution) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_SELECTED),
    redistribution,
})
export const setMarkovRedistributionEdit = (redistribution: MarkovRedistribution) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_EDIT),
    redistribution,
})
export const setMarkovRedistributionReloadList = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_RELOAD_LIST),
    value,
})
export const setMarkovRedistributionReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_REDISTRIBUTION_RELOAD_EDIT),
    value,
})
